import { FunctionComponent } from 'react';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { mapSelectOptionWithIntValueToSelectOption } from '../../../app-kit/helpers/mapSelectOptionWithIntValueToSelectOption';
import { useSearchModalsContentQuery } from '../../../graphql/useSearchModalsContentQuery';
import { getPropertyStatusFromUrl } from '../../../helpers/queryStringHelpers/queryStringHelpers';
import { BudgetModal } from '../../../components/BudgetModal/BudgetModal';
import { SearchPropertyStatus } from '../../../types';
import { useAccountContext } from '../../../app-kit/contexts/AccountContext/AccountContext';
import { useRecentSearches } from '@property.com.au/ui-kit';
import { useSearchLandingPageContext } from '../../contexts/SearchLandingPageContext/SearchLandingPageContext';
import { getBudgetPriceOptionsByByPropertyStatus } from '../../../helpers/getBudgetPriceOptionsByPropertyStatus';

interface SearchPageBudgetModalWithDataProps {
  onClose: () => void;
}

export const SearchLandingPageBudgetModalWithData: FunctionComponent<
  SearchPageBudgetModalWithDataProps
> = ({ onClose }) => {
  const { data, fetching } = useSearchModalsContentQuery();

  const { searchQuery } = useSearchLandingPageContext();

  const { isSignedIn } = useAccountContext();
  const { saveRecentLocationSearch } = useRecentSearches({ isSignedIn });

  if (fetching || !data) return null;

  const propertyStatus = getPropertyStatusFromUrl(searchQuery);

  const searchModalsContent = data?.searchModalsContent;
  const budget = searchModalsContent?.modals?.budget;

  const filterOptions = searchModalsContent?.filterOptions;

  let footerContent;
  if (propertyStatus === SearchPropertyStatus.offMarket) footerContent = budget?.footers?.offMarket;
  if (propertyStatus === SearchPropertyStatus.all) footerContent = budget?.footers?.allProperties;

  const { minPrices, maxPrices } = getBudgetPriceOptionsByByPropertyStatus({
    minPrices: filterOptions?.minPricesV2,
    maxPrices: filterOptions?.maxPricesV2,
    propertyStatus,
  });

  return (
    <BudgetModal
      onClose={onClose}
      searchQuery={searchQuery}
      saveRecentLocationSearch={saveRecentLocationSearch}
      title={budget?.title ?? ''}
      subtitle={budget?.subtitle ?? ''}
      footerContent={mapDynamicContentItems(footerContent)}
      minPriceOptions={minPrices.map(mapSelectOptionWithIntValueToSelectOption) ?? []}
      maxPriceOptions={maxPrices.map(mapSelectOptionWithIntValueToSelectOption) ?? []}
    />
  );
};
